import { FuelConsumptionKind } from 'api/dashboard/dtos/FuelConsumptionPerAssetDashboardDto';

export const getConsumptionUnitKey = (fuelKind: FuelConsumptionKind) =>
	fuelKind === 'electric' ? 'vehicle.eletric_consumption_unit' : 'vehicle.average_consumption_unit';

export const formatConsumption = (
	value: number | null | undefined,
	fuelKind: FuelConsumptionKind,
	t: (key: any) => string,
) => {
	const unit = t(getConsumptionUnitKey(fuelKind));
	if (value == null || isNaN(value)) return `– ${unit}`;
	return `${value.toFixed(2).replace('.', ',')} ${unit}`;
};

export const formatConsumptionNumber = (value: number | null | undefined) => {
	if (value == null || isNaN(value)) return '–';
	return value.toFixed(2).replace('.', ',');
};

export const getConsumptionTranslationKeys = (fuelKind: FuelConsumptionKind, isAsset = false) => {
	const base = fuelKind === 'electric'
		? 'dashboard.electric_consumption_per_asset'
		: 'dashboard.fuel_consumption_per_asset';
	// No detalhe do ativo o título/tooltip não dizem "por ativo".
	const assetBase = fuelKind === 'electric'
		? 'dashboard.electric_consumption_asset'
		: 'dashboard.fuel_consumption_asset';
	return {
		title: isAsset ? assetBase : base,
		tooltip: isAsset ? `${assetBase}_tooltip` : `${base}_tooltip`,
		selectPlaceholder: `${base}_select_placeholder`,
		selectHint: `${base}_select_hint`,
		noMotorization: `${base}_no_motorization`,
	};
};
